import { AUTHORIZATION_SURFACE_COVERAGE, } from '../../compass-capability-registry/dist/index.js';
export const V1_MIGRATION_DISPOSITIONS = [
    'preserveIntentionally',
    'legacyDebt',
    'doNotReproduce',
];
/**
 * Planning evidence only. Nothing here grants authority or becomes a default
 * policy. Every Increment 2A coverage surface is referenced at least once.
 */
export const V1_AUTHORIZATION_MIGRATION_PLAN = Object.freeze([
    {
        id: 'preserve-tenant-and-resource-scope',
        coverageIds: AUTHORIZATION_SURFACE_COVERAGE.map((surface) => surface.id),
        disposition: 'preserveIntentionally',
        behavior: 'Tenant isolation, explicit district/council scope, ownership, participation, and resource relationships remain authorization inputs.',
        rationale: 'Capabilities and scope do not replace tenant or resource-context security constraints.',
        targetCapabilityKeys: [],
    },
    {
        id: 'migrate-role-key3-chair-gates',
        coverageIds: [
            'account-administration', 'actions', 'contacts', 'goals', 'initiatives-and-calendar',
            'permissions-policy', 'strategy', 'tasks', 'operational-user-access',
        ],
        disposition: 'legacyDebt',
        behavior: 'Admin, chair, committee, councilWide, and Key 3 booleans currently select operational access in multiple layers.',
        rationale: 'Later compiler and enforcement increments should replace these gates with explicit compiled grants and scope.',
        targetCapabilityKeys: [],
    },
    {
        id: 'migrate-admin-callable-gates',
        coverageIds: ['advancement', 'data-imports', 'renewal', 'training', 'units-and-exports'],
        disposition: 'legacyDebt',
        behavior: 'Tenant-admin checks currently guard human-triggered imports, automation previews/runs, and recomputation.',
        rationale: 'Operationally assignable capabilities should replace only the Position-policy portions. Data Imports remains exclusively in the tenant-admin authority plane.',
        targetCapabilityKeys: [
            'advancement.previewAutomation', 'advancement.runAutomation',
            'renewal.previewAutomation', 'renewal.runAutomation',
            'training.previewAutomation', 'training.runAutomation',
            'units.recomputeHealth',
        ],
    },
    {
        id: 'preserve-separate-administration-planes',
        coverageIds: ['account-administration', 'application-settings', 'permissions-policy', 'system-administration'],
        disposition: 'preserveIntentionally',
        behavior: 'Account administration, product administration, and entitlements are separate from operational Position authority.',
        rationale: 'Operational policy must never become a self-escalation path into these planes.',
        targetCapabilityKeys: [],
    },
    {
        id: 'reject-email-and-display-name-policy',
        coverageIds: ['fos', 'units-and-exports', 'communications'],
        disposition: 'doNotReproduce',
        behavior: 'Email allowlists, literal Position-name authorization, and broad generic-role shortcuts exist in V1.',
        rationale: 'V2 policy uses stable Position IDs, canonical capability keys, and explicit scope ceilings instead.',
        targetCapabilityKeys: [],
    },
]);
